import React from 'react';

const TermsOfService = () => {
  return (
    <div className="text-gray-900">
      <h1 className="mb-1 text-xl font-semibold md:text-2xl">Terms of Service — 411 Group</h1>

      <section className="space-y-4 text-sm leading-6 text-gray-800">
        <div>
          <h2 className="mb-1 font-semibold">1. Agreement</h2>
          <p>
            These Terms govern access to and use of 411 Group’s Entrepreneur Development Platform
            (the “Platform”), operated by 411 Group of Investments (Pty) Ltd, Botswana. By creating
            an account or using the Platform, you accept these Terms. If you do not agree, do not
            use the Platform.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">2. Eligibility</h2>
          <p>
            Users must be 18+ and legally capable of forming contracts. If acting for an entity, you
            warrant authority to bind it.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">3. Accounts</h2>
          <p>
            Provide accurate information, keep credentials secure, and promptly report unauthorised
            use. You are responsible for activity on your account.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">4. Services</h2>
          <p>
            The Platform includes client management, entrepreneur development (training, coaching,
            mentorship, M&E), and programme support tools.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">5. Acceptable Use</h2>
          <p>
            No unlawful, infringing, misleading, defamatory, harmful, or disruptive activities. Do
            not interfere with security or attempt unauthorised access. Breach may result in
            suspension/termination.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">6. Privacy</h2>
          <p>
            Your use is subject to our Privacy Policy and Cookie Policy. We process data per
            Botswana Data Protection Act (2018), POPIA, and GDPR as applicable.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">7. Intellectual Property</h2>
          <p>
            Platform content and software are owned by 411 Group or licensors. Users own their
            submitted data but grant 411 Group and programme partners a limited licence to use it
            for service delivery, monitoring, and reporting.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">8. Fees</h2>
          <p>
            Where fees apply, you will be notified in advance. Paid amounts are non‑refundable
            unless stated otherwise.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">9. Disclaimers; Liability</h2>
          <p>
            The Platform is provided “as is” and “as available”. We do not warrant uninterrupted or
            error‑free service, or specific outcomes. To the fullest extent permitted by law, 411
            Group is not liable for indirect or consequential loss.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">10. Termination</h2>
          <p>
            We may suspend or terminate for breach or risk. You may close your account at any time.
            Post‑termination, access ceases; we may retain data as required by law or programme
            obligations.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">11. Third‑Party Services</h2>
          <p>
            Integrations may be subject to third‑party terms. 411 Group is not responsible for such
            services.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">12. Governing Law</h2>
          <p>
            These Terms are governed by the laws of Botswana. Courts of Gaborone have jurisdiction,
            subject to mandatory local law.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">13. Changes</h2>
          <p>
            We may update these Terms to reflect legal or service changes. The “Last Updated” date
            indicates the current version.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">14. Contact</h2>
          <p>
            411 Group of Investments (Pty) Ltd
            <br />
            P O Box 99 Lentswe-le-Moriti, Tuli Block, Botswana
            <br />
            Email: info@411group.co.bw
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
